import { useDispatch, useSelector } from "react-redux";
import { HomeOutlined, UnorderedListOutlined, PlusCircleOutlined, EditOutlined } from "@ant-design/icons";
import { Container, Row, Breadcrumb, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import AdminDashboard from "./AdminDashboard";
import UserDashboard from "./UserDashboard";
import { fetchProfile } from "../store/profileApi/profileThunk";
import { useEffect } from "react";

const Dashboard = () => {
    // Redux'dan user ma'lumotlarini olish
    const dispatch = useDispatch();
    const { profile, loading } = useSelector((state) => state.profileApi);

    console.log(profile);
    useEffect(() => {
        dispatch(fetchProfile());
      }, [dispatch]);
    

    // Agar ma'lumotlar yuklanayotgan bo'lsa
    if (loading) {
        return (
            <Container fluid className="p-4 d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                <Spinner animation="border" variant="primary" />
            </Container>
        );
    }

    // Superadmin tekshiruvi
  const isSuperAdmin =
  profile?.roles?.some(role => role.code === 'superadmin' || role.code === 'admin') ||
  profile?.is_superadmin === true;

    // Agar superadmin bo'lsa AdminDashboard ko'rsatish
    if (isSuperAdmin) {
        return <AdminDashboard />;
    }

    // Aks holda UserDashboard ko'rsatish
    return <UserDashboard />;
};

export default Dashboard;